// API base URL for "Try it" and code snippets in API Reference. Must be in backend CORS allowed origins.
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.signtada.com';
